import { render } from "./FoundersImportUpload.vue?vue&type=template&id=1abd64c3"
import script from "./FoundersImportUpload.vue?vue&type=script&lang=js"
export * from "./FoundersImportUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__